import { Component, ViewChild } from '@angular/core';
import { ApiClientService } from '../../services/api-client.service';

@Component({
  selector: 'app-pregled-ip',
  templateUrl: './pregled-ip.component.html',
  styleUrls: ['./pregled-ip.component.scss']
})
export class PregledIpComponent {
  @ViewChild('ipGrid', { static: false }) ipGrid: any;

  gridData: any[] = [];
  loading = false;
  loadPanelPosition = { of: '#ipGrid' };

  // Store users with multiple IPs
  usersWithMultipleIPs: Set<string> = new Set();

  constructor(private apiClient: ApiClientService) { }

  ngOnInit() {
    this.loadIpLogs();
  }

  async loadIpLogs() {
    this.loading = true;
    try {
      this.gridData = await this.apiClient.ipAll();
      this.analyzeMultipleIPs();
    } catch (error) {
      console.error('Error loading IP logs:', error);
    } finally {
      this.loading = false;
    }
  }

  // Analyze which users have multiple IP addresses
  private analyzeMultipleIPs() {
    const userIPs = new Map<string, Set<string>>();

    // Group IPs by username
    this.gridData.forEach(log => {
      if (!userIPs.has(log.username)) {
        userIPs.set(log.username, new Set());
      }
      userIPs.get(log.username)!.add(log.ip);
    });

    // Find users with multiple IPs
    this.usersWithMultipleIPs.clear();
    userIPs.forEach((ips, username) => {
      if (ips.size > 1) {
        this.usersWithMultipleIPs.add(username);
      }
    });

    console.log('Users with multiple IPs:', Array.from(this.usersWithMultipleIPs));
  }

  // Style rows for users with multiple IPs
  onRowPrepared(e: any) {
    if (e.rowType === 'data' && e.data.username) {
      if (this.usersWithMultipleIPs.has(e.data.username)) {
        // Add warning class for users with multiple IPs
        e.rowElement.classList.add('multiple-ip-warning');

        // Optional: Add tooltip
        e.rowElement.title = 'Korisnik se prijavio s više IP adresa';
      }
    }
  }

  onRefreshClick() {
    this.loadIpLogs();
  }
}
